import GeneralBonuses from './components/GeneralBonuses';
import VipBonuses from './components/VipBonuses';

import styles from './Bonuses.module.css';

const Bonuses = () => (
  <div>
    <div className={styles.content}>
      <VipBonuses />

      <GeneralBonuses />
    </div>
  </div>
);

export default Bonuses;
